import { Button, Text } from "@/elements"
import { ampli } from "@/ampli"
import { useEffect } from "react"
import Link from "next/link"

export const MobileJoinNovaOverlay: React.FC<{
  onDismiss: () => void
}> = ({ onDismiss }) => {
  const handleButtonClick = () => {
    onDismiss()
  }

  useEffect(() => {
    document.body.style.overflow = "hidden"

    return () => {
      document.body.style.overflow = ""
    }
  }, [])

  return (
    <div className="fixed bottom-0 left-0 right-0 top-0 z-[100] flex bg-fg-2 sm:hidden">
      <div className="absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 transform p-4">
        <div className="relative">
          <div className="z-30 w-full gap-2 rounded-xl bg-bg-1 p-3">
            <Text className="text-center text-fg-1" variant="h5">
              Join NOVA to access our network of creatives
            </Text>
            <Link href="/sign-up">
              <Button variant="primary" size="large" className="mt-4 w-full" onClick={handleButtonClick}>
                Sign up for NOVA
              </Button>
            </Link>
          </div>
          <Button
            onClick={onDismiss}
            variant="white"
            size="large"
            className="absolute bottom-[-56px] left-0 mt-2 w-full">
            Dismiss
          </Button>
        </div>
      </div>
    </div>
  )
}
